{
  "messages": [],
  "pipeData": {
    "get.contract.detail": {
      "messages": [],
      "data": [
        {
          "id": 1001,
          "contractIdentifier": "BM-CTR-0001",
          "partnerDtoName": "Nürnberger",
          "productDtoName": "Unfallversicherung (856437906)",
          "startDate": "2020-01-01",
          "endDate": null,
          "baseStatusEnumName": "ACTIVE"
        }
      ]
    },
    "get.contract.payment.account": {
      "messages": [],
      "data": [
        {
          "billingAreaDtoName": "Monthly",
          "frequencyEnumName": "MONTHLY",
          "currency": "EUR",
          "paymentTiming": "IN_ADVANCE",
          "paymentDayOfMonth": "D01",
          "paymentMethod": "SEPA_DIRECT_DEBIT",
          "startDate": "2020-01-01",
          "endDate": null,
          "closed": false,
          "bankAccountName": "Marko Milakovic MM6NAKF5F9",
          "iban": "DE82120965970008163847"
        },
        {
          "billingAreaDtoName": "Monthly",
          "frequencyEnumName": "MONTHLY",
          "currency": "EUR",
          "paymentTiming": "IN_ADVANCE",
          "paymentDayOfMonth": "D01",
          "paymentMethod": "SEPA_TRANSFER",
          "startDate": "2017-05-17",
          "endDate": "2019-12-31",
          "closed": true,
          "bankAccountName": "Marko Milakovic (Old)",
          "iban": "DE11111111111111111111"
        },
        {
          "billingAreaDtoName": "Monthly",
          "frequencyEnumName": "MONTHLY",
          "currency": "EUR",
          "paymentTiming": "IN_ADVANCE",
          "paymentDayOfMonth": "D01",
          "paymentMethod": "SEPA_TRANSFER",
          "startDate": "2017-05-17",
          "endDate": "2019-12-31",
          "closed": true,
          "bankAccountName": "Marko Milakovic (Old)",
          "iban": "DE11111111111111111111"
        }
      ]
    },
    "get.contract.price.history": {
      "messages": [],
      "data": [
        {
          "startDate": "2020-01-01",
          "priceFrequencyDtoName": "Monthly",
          "priceGross": 10,
          "currency": "EUR"
        },
        {
          "startDate": "2023-01-01",
          "priceFrequencyDtoName": "Monthly",
          "priceGross": 12,
          "currency": "EUR"
        }
      ]
    },
    "get.contract.payment.planned.entries": {
      "messages": [],
      "data": [
        {
          "contractDtoId": 1001,
          "contractDtoName": "BM-CTR-0001",
          "startDate": "2025-02-01",
          "endDate": "2025-02-01",
          "dueDate": "2025-02-01",
          "plannedTypeDtoName": "Beitrag: SEPA gescheitert",
          "status": "DEBIT",
          "amount": 12.17,
          "remainingAmount": 12.17,
          "currency": "EUR"
        },
        {
          "contractDtoId": 1001,
          "contractDtoName": "BM-CTR-0001",
          "startDate": "2025-02-01",
          "endDate": "2025-02-01",
          "dueDate": "2025-02-01",
          "plannedTypeDtoName": "Bankrücklaufgebühr",
          "status": "DEBIT",
          "amount": 61.9,
          "remainingAmount": 19.07,
          "currency": "EUR"
        },
        {
          "contractDtoId": 1001,
          "contractDtoName": "BM-CTR-0001",
          "startDate": "2025-03-01",
          "endDate": "2025-03-01",
          "dueDate": "2025-03-01",
          "plannedTypeDtoName": "Beitrag",
          "status": "DEBIT",
          "amount": 12.17,
          "remainingAmount": 31.24,
          "currency": "EUR"
        },
        {
          "contractDtoId": 1001,
          "contractDtoName": "BM-CTR-0001",
          "startDate": "2025-03-17",
          "endDate": "2025-03-17",
          "dueDate": "2025-03-17",
          "plannedTypeDtoName": "Überweisung",
          "status": "CREDIT",
          "amount": 31.24,
          "remainingAmount": 0,
          "currency": "EUR"
        },
        {
          "contractDtoId": 1001,
          "contractDtoName": "BM-CTR-0001",
          "startDate": "2025-04-01",
          "endDate": "2025-04-01",
          "dueDate": "2025-04-01",
          "plannedTypeDtoName": "Beitrag",
          "status": "DEBIT",
          "amount": 12.17,
          "remainingAmount": 12.17,
          "currency": "EUR"
        }
      ]
    }
  }
}
